export * from './modules.js';

import * as def from './modules.js';
window.HelixReact = def;
export default def;
